module.exports = __webpack_public_path__ + "img/ico01.49c3a062.svg";